// /src/components/Modals/UnsafeLoginModal.tsx

// What? A modal for logging in without a password.
// Why? To allow users to login without a password.
// How?
// - Uses a Modal component to display the modal.
// - Uses a ModalDialog component to display the modal content.
// - Uses a FormControl component to display the form.
// - Uses a FormLabel component to display the label for the user name.

import React from "react";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";
import Modal from "@mui/joy/Modal";
import ModalDialog from "@mui/joy/ModalDialog";
import DialogTitle from "@mui/joy/DialogTitle";
import Stack from "@mui/joy/Stack";
import Input from "@mui/joy/Input";
import { Button, Box } from "@mui/joy";

interface UnsafeLoginModalProp {
  handleLogin: (event: React.FormEvent<HTMLFormElement>) => void;
}

const UnsafeLoginModal: React.FC<UnsafeLoginModalProp> = ({ handleLogin }) => {
  return (
    <Modal open={true}>
      <ModalDialog className="modal">
        <DialogTitle>Login</DialogTitle>
        <form onSubmit={handleLogin}>
          <Stack spacing={2}>
            <FormControl>
              <FormLabel>User Name</FormLabel>
              <Input
                name="userName"
                className="inputField"
                autoFocus
                required
                placeholder="admin"
              />
            </FormControl>
            <Box sx={{ display: "flex", gap: 1, justifyContent: "flex-end" }}>
              <Button variant="solid" color="primary" type="submit">
                Login
              </Button>
            </Box>
          </Stack>
        </form>
      </ModalDialog>
    </Modal>
  );
};

export default UnsafeLoginModal;
